import { colors } from "../Styles"

/* eslint-disable no-unused-vars */
export enum ToggleStyles {
  tableToggle = "tableToggle",
  greyTertiary = "greyTertiary",
  greySecondary = "greySecondary",
  blueDarkSecondary = "blueDarkSecondary"
}
/* eslint-enable no-unused-vars */

export const createToggleStyle = (checkStyle?: ToggleStyles | string, focus_view?:boolean ) => {
  let colorStyle = ""
  let height = ""
  let width = ""
  let circleSize = ""
  let textColor = ""

  switch (checkStyle) {
    case ToggleStyles.tableToggle:
      colorStyle = colors.greyTertiary
      height = "25px"
      width = "43px"
      circleSize = "20px"
      textColor = colors.greyDarkPrimary
      break
    
    case ToggleStyles.greyTertiary:
      colorStyle = colors.greyTertiary
      height = "30px"
      width = "50px"
      circleSize = "23px"
      textColor = colors.greyDarkPrimary
    break
    
    case ToggleStyles.blueDarkSecondary:
      colorStyle = colors.blueDarkSecondary
      height = "30px"
      width = "50px"
      circleSize = "23px"
      textColor = colors.greyLightTertiary
    break
  
    case ToggleStyles.greySecondary:
    default:
      colorStyle = colors.greySecondary
      height = "30px"
      width = "50px"
      circleSize = "23px"
      textColor = colors.greyLightTertiary
    break
  }

  return {colorStyle, height, width, circleSize, textColor}
}